import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import { ChooseScreensComponent } from "./choose-screen/choose-screen.component";

import { CreateComponent } from "./create/create.component";

const routes: Routes = [
	{path: '', component: CreateComponent},
	{path: ':id', component: CreateComponent},
	{path: 'screens/:diffusionId', component: ChooseScreensComponent}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class PrivateCampaignRoutingModule {}
